module.exports = __webpack_public_path__ + "static/iso-luggage-512-83e8d5412b2027d5280f8f5e405b3921.png";